import { useTranslation } from 'react-i18next';
import { computeScore, grade } from '../lib/preservation';

function PreservationScore({ verdict }) {
  const { t } = useTranslation();

  if (!verdict || !verdict.totalGames) return null;

  const score = computeScore(verdict);
  const g = grade(score);

  return (
    <div className={`pscore pscore--${g.tone}`}>
      <span className="pscore__grade">{g.letter}</span>
      <div className="pscore__gauge">
        <div className="pscore__gaugehead">
          <span className="pscore__caption">{t('pscore.your_score')}</span>
          <span className="pscore__num">{score}<em>/100</em></span>
        </div>
        <div className="pscore__track">
          <span className="pscore__fill" style={{ width: `${score}%` }} />
        </div>
      </div>
    </div>
  );
}

export default PreservationScore;
